/*
Briques visuelles partagées des calendriers « clairs » (design v5) : pilule de
recherche de la home / popin du header, et cartouche de réservation de la fiche lieu.
Classes explicites aux tokens was-*, aucune surcharge CSS de la version sombre.
*/

export function Chevron({ dir }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {dir === 'left' ? <path d="m15 18-6-6 6-6" /> : <path d="m9 18 6-6-6-6" />}
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

export function CloseIcon({ className = '' }) {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </svg>
  );
}

/* En-tête du mois : bouton chevron. */
export const navBtnClass = 'flex h-8 w-8 items-center justify-center rounded-full text-was-ink transition hover:bg-was-ink/6 disabled:cursor-default disabled:opacity-25 disabled:hover:bg-transparent';
export const monthTitleClass = 'text-[15px] font-bold text-was-ink';
export const weekdayClass = 'pb-1 text-center text-[11px] font-medium uppercase tracking-[0.08em] text-was-muted';
export const sectionTitleClass = 'text-[11px] font-bold uppercase tracking-[0.12em] text-was-muted';

/*
Lettres des jours (lundi → dimanche) et nom du mois pris à dayjs dans la locale
courante, et non à l'espace i18n `date` que toutes les pages ne chargent pas.
*/
export function weekLetters(dayjs, locale) {
  return [1, 2, 3, 4, 5, 6, 7].map((d) => {
    const short = dayjs().day(d).locale(locale).format('dd');
    return short.charAt(0).toUpperCase();
  });
}

export function monthLabel(dayjs, date, locale) {
  const m = date.locale(locale).format('MMMM');
  const name = m.charAt(0).toUpperCase() + m.slice(1);
  return date.year() === dayjs().year() ? name : `${name} ${date.year()}`;
}

/*
Case d'un jour : sélectionné = pastille violette pleine (la période ou le créneau se
lit dans la liste sous le calendrier), menu ouvert = violet pâle, désactivé = grisé.
*/
export function dayClass({ disabled, selected, open }) {
  let tone = 'text-was-ink hover:bg-was-violet/10 hover:text-was-violet cursor-pointer';
  if (disabled) tone = 'text-was-ink/25 cursor-default';
  else if (selected) tone = 'bg-was-violet text-white hover:bg-was-violet-dark cursor-pointer';
  else if (open) tone = 'bg-was-violet/12 text-was-violet cursor-pointer';
  return `relative flex h-9 w-9 items-center justify-center rounded-lg text-sm font-medium transition ${tone}`;
}

export const todayDotClass = 'absolute bottom-1 h-1 w-1 rounded-full bg-was-violet';

/* Menu de période ancré sous le jour. */
export const menuClass = 'relative w-44 rounded-xl border border-was-ink/8 bg-white p-1.5 text-left shadow-[0_1px_2px_rgba(19,14,27,0.06),0_12px_28px_-8px_rgba(19,14,27,0.3)]';
export const menuDividerClass = 'my-1 h-px bg-was-ink/8';
export const menuDangerClass = 'flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm font-medium text-red transition hover:bg-red/10';

export function menuItemClass(selected) {
  return `flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-left text-sm font-medium transition ${selected
    ? 'bg-was-violet/10 text-was-violet cursor-default'
    : 'text-was-ink hover:bg-was-violet/10 hover:text-was-violet cursor-pointer'}`;
}

/* Bouton rond « retirer » (croix). */
export const removeBtnClass = 'flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-was-muted transition hover:bg-was-ink/6 hover:text-was-ink';

/*
Sélecteur natif habillé en pastille : le chevron est dessiné en fond pour rester
cliquable partout.
*/
export const selectClass = 'appearance-none rounded-lg border border-was-ink/10 bg-white py-1 pl-2.5 pr-7 text-xs font-medium text-was-ink transition hover:border-was-ink/25 focus:border-was-violet focus:outline-none focus:ring-0 cursor-pointer disabled:cursor-default disabled:opacity-40';
export const selectStyle = {
  backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%237d7a8a' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><path d='m6 9 6 6 6-6'/></svg>\")",
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 8px center',
};
